import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
    name: 'nestedFieldAccessor',
    standalone: true,
})
export class NestedFieldAccessorPipe implements PipeTransform {
    transform(value: any, path: string): any {
        if (!value || !path) {
            return null;
        }

        return path.split('.').reduce((o, i) => (o ? o[i] : undefined), value);
    }
}
